module.exports = __webpack_public_path__ + "38dfa23a36e1e72303eaa3dbbd9db11a.svg";